import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchServices,
  updateService,
  addService,
  deleteService,
} from '../redux/slices/serviceSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../modalstyles/WebsiteServicesModal.css';

const WebsiteServicesModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { list: services, loading, currentPage, totalPages } = useSelector((state) => state.services);

  const [newService, setNewService] = useState('');
  const loaderRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    dispatch(fetchServices(1));
  }, [dispatch]);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && currentPage < totalPages && !loading) {
        dispatch(fetchServices(currentPage + 1));
      }
    }, {
      root: containerRef.current,
      threshold: 1.0,
    });

    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [currentPage, totalPages, loading, dispatch]);

  const toggleService = async (service) => {
    try {
      await dispatch(
        updateService({
          id: service.id,
          updatedData: { ...service, isEnabled: !service.isEnabled },
        })
      ).unwrap();
      toast.success('Status updated');
    } catch (err) {
      toast.error('Update failed');
    }
  };

  const handleAddService = async () => {
    if (newService.trim()) {
      try {
        await dispatch(addService({ name: newService, isEnabled: true })).unwrap();
        toast.success('Service added');
        setNewService('');
      } catch (err) {
        toast.error('Failed to add service');
      }
    }
  };

  const handleDeleteService = async (id) => {
    if (window.confirm('Are you sure you want to delete this service?')) {
      try {
        await dispatch(deleteService(id)).unwrap();
        toast.success('Service deleted');
      } catch (err) {
        toast.error('Delete failed');
      }
    }
  };

  return (
    <div className="WebsiteServicesModal-backdrop">
      <div className="WebsiteServicesModal-modal">
        <div className="WebsiteServicesModal-header">
          <h3 className="WebsiteServicesModal-title">Manage Website Services</h3>
          <button onClick={onClose} className="WebsiteServicesModal-closeBtn">&times;</button>
        </div>

        <div className="WebsiteServicesModal-body" ref={containerRef} style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <div className="WebsiteServicesModal-addRow">
            <input
              type="text"
              value={newService}
              onChange={(e) => setNewService(e.target.value)}
              placeholder="New Service Name"
              className="WebsiteServicesModal-input"
            />
            <button onClick={handleAddService} className="WebsiteServicesModal-addBtn">
              Add Service
            </button>
          </div>

          {loading && services.length === 0 ? (
            <p>Loading...</p>
          ) : (
            services.map((service) => (
              <div key={service.id} className="WebsiteServicesModal-row">
                <label>{service.name}</label>
                <div className="WebsiteServicesModal-actions">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={service.isEnabled}
                      onChange={() => toggleService(service)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <button
                    className="WebsiteServicesModal-deleteBtn"
                    onClick={() => handleDeleteService(service.id)}
                  >
                    🗑
                  </button>
                </div>
              </div>
            ))
          )}

          <div ref={loaderRef} style={{ height: '40px' }} />
        </div>

        <div className="WebsiteServicesModal-footer">
          <button className="WebsiteServicesModal-saveBtn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default WebsiteServicesModal;